import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import { Link } from 'react-router-dom';

import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import FireTruckOutlinedIcon from '@mui/icons-material/FireTruckOutlined';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import Person3OutlinedIcon from '@mui/icons-material/Person3Outlined';
import BatterySaverOutlinedIcon from '@mui/icons-material/BatterySaverOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';

const services = [
  {
    title: "Transport Operations",
    description:
      "Manage dispatch, delivery routes, loading/unloading, and fleet scheduling from a central dashboard.",
    icon: <LocalShippingOutlinedIcon sx={{ fontSize: 40 }} />,
  },
  {
    title: "Fleet Management",
    description:
      "Monitor vehicle health, service records, mileage, and real-time tracking to optimize usage and maintenance.",
    icon: <FireTruckOutlinedIcon sx={{ fontSize: 40 }} />,
  },
  {
    title: "Vehicle Dues/Documents",
    description:
      "Never miss a due date with automated reminders for insurance, permits, pollution, and more.",
    icon: <DocumentScannerOutlinedIcon sx={{ fontSize: 40 }} />,
  },
  {
    title: "Tyre Management",
    description:
      "Track tyre life cycle, pressure logs, rotation schedules, and replacements to ensure road safety.",
    icon: <RadioButtonCheckedIcon sx={{ fontSize: 40 }} />,
  },
  {
    title: "Driver Management",
    description:
      "Manage driver profiles, license validity, trip history, attendance, and performance reviews.",
    icon: <Person3OutlinedIcon sx={{ fontSize: 40 }} />,
  },
  {
    title: "Battery Management",
    description:
      "Keep tabs on battery usage patterns, health indicators, and replacement timelines.",
    icon: <BatterySaverOutlinedIcon sx={{ fontSize: 40 }} />,
  },
  {
    title: "Payroll Management",
    description:
      "Automate payroll processing, deductions, bonuses, and generate salary slips for all staff.",
    icon: <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 40 }} />,
  },
  {
    title: "E-Invoicing",
    description:
      "Generate GST-compliant invoices with transport charges, taxes, and direct integration to finance modules.",
    icon: <ReceiptOutlinedIcon sx={{ fontSize: 40 }} />,
  },
];

export default function ServicesSection() {
  return (
    <Box
      sx={{
        py: 10,
        background: "linear-gradient(to bottom right, #7AB2D3, #8ae97d)",
      }}
    >
      <Container>
        <Typography
          variant="h4"
          align="center"
          sx={{
            color: "#ffffff",
            fontWeight: 700,
            mb: 5,
            textTransform: "uppercase",
            letterSpacing: 1.5,
            textShadow: '1px 1px 4px rgba(0,0,0,0.4)',
          }}
        >
          Our Services
        </Typography>

        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  width: "100%",
                  maxWidth: "250px",
                  textAlign: "center",
                  backgroundColor: "#f1f8f6",
                  color: "#000000",
                  borderRadius: 2,
                  p: 4,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "linear-gradient(to bottom right, #5b58f0, #46e238)",
                    transform: "scale(1.05)",
                    color: "#ffffff",
                    boxShadow: 6,
                  },
                }}
              >
                <Box mb={2}>{service.icon}</Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  {service.title}
                </Typography>
                <Typography variant="body2">
                  {service.description}
                </Typography>
                <Button
                  component={Link}
                  to="/services"
                  variant="contained"
                  size="small"
                  sx={{
                    mt: 2,
                    backgroundColor: "#7AB2D3",
                    borderRadius: "20px",
                    fontWeight: 600,
                    "&:hover": {
                      backgroundColor: "#4A628A",
                    },
                  }}
                >
                  Know More
                </Button>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
